<template>
  <div class="header-box">
    <div class="header-left">
      <div class="logo clearfix">
        <div class="fl">
          <img src="../assets/logo_ld.png"
               alt="">
        </div>
        <div class="fl">
          <div class="logoTitle">魔镜CMI</div>
          <div class="logoText">MKTINDEX.COM</div>
        </div>
        <div class="fl">
          <el-popover placement="bottom-start"
                      trigger="hover">
            <div>
              <img src="../assets/kf.png"
                   alt="">
            </div>
            <div style="text-align:center;">扫码联系售后人员</div>
            <i class="iconfont icon-kefu kf"
               slot="reference"><span class="text" style="font-style: normal">售后支持</span></i>
          </el-popover>
          <div class="inspiration-text"
               @click="jumpToInspiration">
            <i class="iconfont icon-dengpao dp" />
            <span class="icon-text-dp">{{ inspiration }}</span>
          </div>
          <div class="usage-scenario">
            <i class="el-icon-notebook-2 notebook"></i>
            <a href="https://qmctsz2s8t.feishu.cn/docx/Vx2Udr2JBoDF1Gxb2Wcc3hAOnAd"
              target="_blank"
              class="scenario">头部品牌都在看的场景大全</a>
          </div>
        </div>
      </div>
    </div>
    <div class="header-right">
      <userinfo @userLogin="userLoginValue"> </userinfo>
    </div>

  </div>
</template>

<script>
import { userinfo } from 'common'
export default {
  components: {
    userinfo,
  },
  data() {
    return {
      loginInfo: {},
    }
  },
  props: {
    showInspiration: {
      default: false,
      type: Boolean,
    }
  },
  computed: {
    inspiration() {
      if (!this.showInspiration) {
        return '灵感中心'
      } else {
        return '返回CMI平台'
      }
    }
  },
  methods: {
    userLoginValue(val) {
      this.loginInfo = val
    },
    jumpToInspiration() {
      this.$emit('inspiration')
    }
  },
  watch: {},
  created () {},
}
</script>

<style scoped lang='less'>
.header-left {
  color: #fff;
  .lb {
    display: inline-block;
  }
  .logo {
    img {
      height: 35px;
      margin-top: 10px;
      margin-right: 12px;
    }
    .fl {
      float: left;
    }
    .fr {
      float: right;
    }
    .logoTitle {
      font-size: 16px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #fff;
      margin-top: 14px;
      line-height: 20px;
      text-align: center;
    }
    .logoText {
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: #fff;
      transform: scale(0.7);
      text-align: center;
      line-height: 10px;
    }
  }
  .kf {
    margin-left: 30px;
    cursor: pointer;
    line-height: 56px;
    font-size: 20px;
  }
  .text {
    display: inline-block;
    font-size: 14px;
    vertical-align: top;
    margin-left: 4px;
  }
  .inspiration-text {
    cursor: pointer;
    display: inline-block;
    vertical-align: top;
    line-height: 56px;
    margin-left: 20px;
    .dp {
      font-size: 16px;
    }
    .icon-text-dp {
      font-size: 14px;
    }
  }
  .usage-scenario {
    display: inline-block;
    vertical-align: top;
    line-height: 56px;
    margin-left: 20px;
    .notebook {
      font-size: 16px;
    }
    .scenario {
      font-size: 14px;
      color: #ffffff;
    }
    .scenario:hover,
    .scenario:focus {
      text-decoration: unset;
    }
  }
}
.header-right {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #fff;
  .el-dropdown-link {
    color: #fff;
  }
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
}
</style>
